import React, { useState } from 'react';
import { PageHeader } from '../components/shared/PageHeader';
import { ReviewCard } from '../components/shared/ReviewCard';
import { Stars } from '../components/shared/Stars';
import { Reveal } from '../components/shared/Reveal';
import { CtaBand } from '../components/shared/CtaBand';
import { useLanguage } from '../contexts/LanguageContext';
import { business, reviewMeta, type Kind } from '../data/site';
import { useSeo } from '../hooks/useSeo';
type Filter = 'all' | Kind;
export function Reviews() {
  const {
    t,
    lang
  } = useLanguage();
  const page = t.reviews.page;
  const [filter, setFilter] = useState<Filter>('all');
  useSeo({
    ...t.common.seo.reviews,
    lang
  });
  const shown = filter === 'all' ? reviewMeta : reviewMeta.filter(r => r.kind === filter);
  const filters: Filter[] = ['all', 'flowers', 'balloons', 'both'];
  return <main data-id="element-501" data-mp="3863bv2vojx26">
      <PageHeader eyebrow={page.eyebrow} title={page.title} description={page.description} data-id="element-502" data-mp="386d3sw0aceai">
        <div className="flex flex-wrap items-center gap-x-8 gap-y-6" data-id="element-503" data-mp="3c3hiqnvw1sr0">
          <div className="flex items-center gap-4" data-id="element-504" data-mp="2qixqqrz9lch">
            <span className="font-display text-5xl font-semibold text-mauve-deep" data-id="element-505" data-mp="3twagv67c7xps">{business.rating.toFixed(1)}</span>
            <div data-id="element-506" data-mp="bqo2su9p87nh">
              <Stars count={5} label={t.common.starsLabel} size="md" data-id="element-507" data-mp="br79fetwf9m7" />
              <p className="mt-1 text-sm text-ink/60" data-id="element-508" data-mp="7oaymaalohst">{page.summary}</p>
            </div>
          </div>
          <div role="group" aria-label={page.filterLabel} className="flex flex-wrap gap-2" data-id="element-509" data-mp="lo29i25tli2l">
            {filters.map(f => <button key={f} type="button" onClick={() => setFilter(f)} aria-pressed={filter === f} className={`h-11 whitespace-nowrap rounded-full border px-5 text-sm transition-colors duration-150 ease-smooth ${filter === f ? 'border-mauve bg-mauve text-white' : 'border-petal bg-white text-ink/75 hover:border-mauve/40 hover:text-mauve'}`} data-id="element-510" data-mp="gophl303dkt5">
                {t.reviews.filters[f]}
              </button>)}
          </div>
        </div>
      </PageHeader>

      <section className="bg-white py-14 sm:py-16" data-id="element-511" data-mp="1zb0dt0edt1m">
        <div className="mx-auto grid max-w-7xl gap-6 px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-3" data-id="element-512" data-mp="62h16l4qqs0p">
          {shown.map((review, i) => <Reveal key={`${filter}-${review.id}`} delay={0.03 * (i % 3)} className="h-full" data-id="element-513" data-mp="avtp0t1liuse" data-mpi={i}>
              <ReviewCard review={review} data-id="element-514" data-mp="fv6d1h47e7wk" />
            </Reveal>)}
        </div>
      </section>

      <CtaBand data-id="element-515" data-mp="ktzqj9jhpywq" />
    </main>;
}